import React, { useEffect, useState } from 'react';

import './SiteFooter.scss';

const SiteFooter = ({globalSiteSettings}) => {
    const [footerMenu, setFooterMenu] = useState([]);
    const [baseUrl, setBaseUrl] = useState("")

    const { siteFooterLogo } = globalSiteSettings;
    useEffect(() => {
        setBaseUrl(window.___appProps.prefix)
        async function fetchData() {
            const sitemap = await window._arvada.api.getSitemapNested();
            setFooterMenu(sitemap);
        }
        fetchData();
    }, []);
    return (
        <div className="container">
            <section className="site-footer">
                <section className="site-footer-logo">
                    {!!siteFooterLogo && <a href={`${baseUrl}/home`} className="footer-logo">
                        <img src={siteFooterLogo.url} />
                    </a>}
                </section>
                <section className="site-footer-sitemap">
                    {!!footerMenu.length &&
                        footerMenu.map(
                            (sitemap, index) =>
                                !!sitemap.title && !!sitemap.visible && !!sitemap.visible.menu && (
                                    <div key={index} className="sitemapItem">
                                        <a href={baseUrl + sitemap.path}>{sitemap.title}</a>
                                    </div>
                                ),
                        )}
                </section>
                <section className="site-footer-social-media">
                    <section className="menu-footer">
                        <h6 className="h6">Follow Us</h6>
                        <section className="social-media">
                            <a href={baseUrl + globalSiteSettings.facebook} target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
                                    <path
                                        fill="#4C4C4C"
                                        fillRule="evenodd"
                                        d="M15.49 29H1.6A1.6 1.6 0 0 1 0 27.4V1.6A1.6 1.6 0 0 1 1.6 0h25.8A1.6 1.6 0 0 1 29 1.6v25.8a1.6 1.6 0 0 1-1.6 1.6h-7.39V17.77h3.77l.564-4.377H20.01v-2.794c0-1.267.351-2.131 2.169-2.131l2.317-.001V4.552c-.4-.053-1.776-.172-3.377-.172-3.341 0-5.63 2.04-5.63 5.785v3.228h-3.778v4.377h3.779V29z"
                                        opacity=".401"
                                    />
                                </svg>
                            </a>
                            <a href={baseUrl + globalSiteSettings.twitter} target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="24" viewBox="0 0 29 24">
                                    <path
                                        fill="#4C4C4C"
                                        fillRule="evenodd"
                                        d="M29 2.841a11.683 11.683 0 0 1-3.416.954A6.052 6.052 0 0 0 28.2.444a11.766 11.766 0 0 1-3.78 1.468A5.886 5.886 0 0 0 20.076 0c-3.283 0-5.947 2.713-5.947 6.059 0 .474.05.936.153 1.38-4.945-.254-9.328-2.663-12.264-6.333a6.136 6.136 0 0 0-.805 3.05A6.087 6.087 0 0 0 3.86 9.197a5.872 5.872 0 0 1-2.697-.756v.075c0 2.936 2.051 5.385 4.775 5.94a5.71 5.71 0 0 1-1.568.213c-.383 0-.757-.036-1.12-.107.758 2.406 2.953 4.159 5.558 4.205a11.799 11.799 0 0 1-7.39 2.595c-.48 0-.954-.027-1.419-.083A16.647 16.647 0 0 0 9.12 24c10.945 0 16.928-9.23 16.928-17.238 0-.263-.005-.527-.015-.785A12.161 12.161 0 0 0 29 2.841"
                                        opacity=".401"
                                    />
                                </svg>
                            </a>
                            <a href={baseUrl + globalSiteSettings.instagram} target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
                                    <path
                                        fill="#4C4C4C"
                                        fillRule="evenodd"
                                        d="M15.788 0c2.785.005 3.331.025 4.69.087 1.544.07 2.598.316 3.52.674.954.37 1.762.867 2.568 1.673a7.108 7.108 0 0 1 1.673 2.568c.358.922.603 1.976.674 3.52.07 1.546.087 2.04.087 5.978 0 3.938-.017 4.432-.087 5.978-.07 1.544-.316 2.598-.674 3.52a7.108 7.108 0 0 1-1.673 2.568 7.108 7.108 0 0 1-2.568 1.673c-.922.358-1.976.603-3.52.674-1.546.07-2.04.087-5.978.087-3.938 0-4.432-.017-5.978-.087-1.544-.07-2.598-.316-3.52-.674a7.108 7.108 0 0 1-2.568-1.673A7.107 7.107 0 0 1 .76 23.998c-.358-.922-.603-1.976-.674-3.52-.062-1.359-.082-1.905-.086-4.69v-2.576c.004-2.785.024-3.331.086-4.69.07-1.544.316-2.598.674-3.52a7.107 7.107 0 0 1 1.673-2.568A7.107 7.107 0 0 1 5.002.76C5.924.403 6.978.158 8.522.087 9.829.027 10.384.007 12.9.001h2.888zm-.62 2.613h-1.335c-3.264.002-3.756.019-5.192.084-1.414.065-2.182.3-2.693.5A4.492 4.492 0 0 0 4.281 4.28c-.507.507-.822.99-1.085 1.667-.198.511-.434 1.279-.499 2.693-.065 1.436-.082 1.928-.084 5.192v1.334c.002 3.264.019 3.756.084 5.192.065 1.414.3 2.182.5 2.693.262.677.577 1.16 1.084 1.667.507.507.99.822 1.667 1.085.511.198 1.279.434 2.693.499 1.436.065 1.928.082 5.192.084h1.334c3.264-.002 3.756-.019 5.192-.084 1.414-.065 2.182-.3 2.693-.5a4.492 4.492 0 0 0 1.667-1.084c.507-.507.822-.99 1.085-1.667.198-.511.434-1.279.499-2.693.065-1.436.082-1.928.084-5.192v-1.334c-.002-3.264-.019-3.756-.084-5.192-.065-1.414-.3-2.182-.5-2.693a4.492 4.492 0 0 0-1.084-1.667 4.492 4.492 0 0 0-1.667-1.085c-.511-.198-1.279-.434-2.693-.499-1.436-.065-1.928-.082-5.192-.084zM14.5 7.054a7.446 7.446 0 1 1 0 14.892 7.446 7.446 0 0 1 0-14.892zm0 2.613a4.833 4.833 0 1 0 0 9.666 4.833 4.833 0 0 0 0-9.666zm7.74-4.647a1.74 1.74 0 1 1 0 3.48 1.74 1.74 0 0 1 0-3.48z"
                                        opacity=".401"
                                    />
                                </svg>
                            </a>
                            <a href={baseUrl + globalSiteSettings.youtube} target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="21" viewBox="0 0 29 21">
                                    <path
                                        fill="#4C4C4C"
                                        fillRule="evenodd"
                                        d="M11.506 14.373l-.001-8.39 7.835 4.21-7.834 4.18zM28.71 4.53s-.284-2.057-1.153-2.963C26.454.377 25.218.37 24.652.302 20.594 0 14.506 0 14.506 0h-.012S8.406 0 4.348.302c-.567.07-1.802.075-2.906 1.265C.572 2.473.29 4.53.29 4.53S0 6.947 0 9.362v2.266c0 2.416.29 4.832.29 4.832s.283 2.057 1.152 2.963c1.104 1.19 2.553 1.152 3.198 1.277 2.32.23 9.86.3 9.86.3s6.094-.01 10.152-.312c.566-.07 1.802-.075 2.905-1.265.87-.906 1.153-2.963 1.153-2.963s.29-2.416.29-4.832V9.362c0-2.415-.29-4.832-.29-4.832z"
                                        opacity=".401"
                                    />
                                </svg>
                            </a>
                        </section>
                        <p>
                            Copyright 2019 Arvada Center
                            <br />
                            for the Arts and Humanities
                        </p>
                    </section>
                </section>
            </section>
        </div>
    );
};

export default SiteFooter;
